/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetDishSupplementsDocument = gql`
    query GetDishSupplements($companyId: Int!, $page: Int, $itemsPerPage: Int, $supplementId: Int, $search: String, $menuCategoryId: Int, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuSupplements(
        page: $page
        itemsPerPage: $itemsPerPage
        id: $supplementId
        search: $search
        menuCategoryId: $menuCategoryId
        locale: $locale
      ) {
        supplements {
          id
          groupName(locale: $locale)
          groupNameOrigin
          items {
            id
            name(locale: $locale)
            nameOrigin
          }
          options {
            id
            name(locale: $locale)
            nameOrigin
            price
            deleted
          }
          numberOfOption
          isRequireOnOrder
          maxCountOnOrder
          deleted
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetDishSupplementsQuery__
 *
 * To run a query within a React component, call `useGetDishSupplementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDishSupplementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDishSupplementsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      supplementId: // value for 'supplementId'
 *      search: // value for 'search'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetDishSupplementsQuery(baseOptions: Apollo.QueryHookOptions<GetDishSupplementsQuery, GetDishSupplementsQueryVariables> & ({ variables: GetDishSupplementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>(GetDishSupplementsDocument, options);
      }
export function useGetDishSupplementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>(GetDishSupplementsDocument, options);
        }
export function useGetDishSupplementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>(GetDishSupplementsDocument, options);
        }
export type GetDishSupplementsQueryHookResult = ReturnType<typeof useGetDishSupplementsQuery>;
export type GetDishSupplementsLazyQueryHookResult = ReturnType<typeof useGetDishSupplementsLazyQuery>;
export type GetDishSupplementsSuspenseQueryHookResult = ReturnType<typeof useGetDishSupplementsSuspenseQuery>;
export type GetDishSupplementsQueryResult = Apollo.QueryResult<GetDishSupplementsQuery, GetDishSupplementsQueryVariables>;
export const GetMenuItemsForSupplementsDocument = gql`
    query GetMenuItemsForSupplements($companyId: Int!, $itemsPerPage: Int, $isDeleted: Boolean, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuItems(itemsPerPage: $itemsPerPage, isDeleted: $isDeleted, locale: $locale) {
        items {
          id
          name(locale: $locale)
          nameOrigin
          categories {
            id
            name(locale: $locale)
            nameOrigin
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemsForSupplementsQuery__
 *
 * To run a query within a React component, call `useGetMenuItemsForSupplementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemsForSupplementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemsForSupplementsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      isDeleted: // value for 'isDeleted'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuItemsForSupplementsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables> & ({ variables: GetMenuItemsForSupplementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>(GetMenuItemsForSupplementsDocument, options);
      }
export function useGetMenuItemsForSupplementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>(GetMenuItemsForSupplementsDocument, options);
        }
export function useGetMenuItemsForSupplementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>(GetMenuItemsForSupplementsDocument, options);
        }
export type GetMenuItemsForSupplementsQueryHookResult = ReturnType<typeof useGetMenuItemsForSupplementsQuery>;
export type GetMenuItemsForSupplementsLazyQueryHookResult = ReturnType<typeof useGetMenuItemsForSupplementsLazyQuery>;
export type GetMenuItemsForSupplementsSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemsForSupplementsSuspenseQuery>;
export type GetMenuItemsForSupplementsQueryResult = Apollo.QueryResult<GetMenuItemsForSupplementsQuery, GetMenuItemsForSupplementsQueryVariables>;
export const CreateMenuSupplementDocument = gql`
    mutation CreateMenuSupplement($companyId: Int!, $input: MenuSupplementInput!, $branchId: Int!, $locale: String) {
  createMenuSupplement(
    companyId: $companyId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
  }
}
    `;
export type CreateMenuSupplementMutationFn = Apollo.MutationFunction<CreateMenuSupplementMutation, CreateMenuSupplementMutationVariables>;

/**
 * __useCreateMenuSupplementMutation__
 *
 * To run a mutation, you first call `useCreateMenuSupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuSupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuSupplementMutation, { data, loading, error }] = useCreateMenuSupplementMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateMenuSupplementMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuSupplementMutation, CreateMenuSupplementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuSupplementMutation, CreateMenuSupplementMutationVariables>(CreateMenuSupplementDocument, options);
      }
export type CreateMenuSupplementMutationHookResult = ReturnType<typeof useCreateMenuSupplementMutation>;
export type CreateMenuSupplementMutationResult = Apollo.MutationResult<CreateMenuSupplementMutation>;
export type CreateMenuSupplementMutationOptions = Apollo.BaseMutationOptions<CreateMenuSupplementMutation, CreateMenuSupplementMutationVariables>;
export const UpdateMenuSupplementDocument = gql`
    mutation UpdateMenuSupplement($companyId: Int!, $dishId: Int!, $input: MenuSupplementInput!, $locale: String, $branchId: Int!) {
  updateMenuSupplement(
    companyId: $companyId
    id: $dishId
    input: $input
    locale: $locale
    branchId: $branchId
  ) {
    id
  }
}
    `;
export type UpdateMenuSupplementMutationFn = Apollo.MutationFunction<UpdateMenuSupplementMutation, UpdateMenuSupplementMutationVariables>;

/**
 * __useUpdateMenuSupplementMutation__
 *
 * To run a mutation, you first call `useUpdateMenuSupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuSupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuSupplementMutation, { data, loading, error }] = useUpdateMenuSupplementMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      dishId: // value for 'dishId'
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateMenuSupplementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuSupplementMutation, UpdateMenuSupplementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuSupplementMutation, UpdateMenuSupplementMutationVariables>(UpdateMenuSupplementDocument, options);
      }
export type UpdateMenuSupplementMutationHookResult = ReturnType<typeof useUpdateMenuSupplementMutation>;
export type UpdateMenuSupplementMutationResult = Apollo.MutationResult<UpdateMenuSupplementMutation>;
export type UpdateMenuSupplementMutationOptions = Apollo.BaseMutationOptions<UpdateMenuSupplementMutation, UpdateMenuSupplementMutationVariables>;
export const DeleteMenuSupplementDocument = gql`
    mutation DeleteMenuSupplement($branchId: Int!, $id: Int!) {
  deleteMenuSupplement(branchId: $branchId, id: $id)
}
    `;
export type DeleteMenuSupplementMutationFn = Apollo.MutationFunction<DeleteMenuSupplementMutation, DeleteMenuSupplementMutationVariables>;

/**
 * __useDeleteMenuSupplementMutation__
 *
 * To run a mutation, you first call `useDeleteMenuSupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuSupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuSupplementMutation, { data, loading, error }] = useDeleteMenuSupplementMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMenuSupplementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuSupplementMutation, DeleteMenuSupplementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuSupplementMutation, DeleteMenuSupplementMutationVariables>(DeleteMenuSupplementDocument, options);
      }
export type DeleteMenuSupplementMutationHookResult = ReturnType<typeof useDeleteMenuSupplementMutation>;
export type DeleteMenuSupplementMutationResult = Apollo.MutationResult<DeleteMenuSupplementMutation>;
export type DeleteMenuSupplementMutationOptions = Apollo.BaseMutationOptions<DeleteMenuSupplementMutation, DeleteMenuSupplementMutationVariables>;
export const RestoreMenuSupplementDocument = gql`
    mutation RestoreMenuSupplement($branchId: Int!, $id: Int!) {
  restoreMenuSupplement(branchId: $branchId, id: $id)
}
    `;
export type RestoreMenuSupplementMutationFn = Apollo.MutationFunction<RestoreMenuSupplementMutation, RestoreMenuSupplementMutationVariables>;

/**
 * __useRestoreMenuSupplementMutation__
 *
 * To run a mutation, you first call `useRestoreMenuSupplementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMenuSupplementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMenuSupplementMutation, { data, loading, error }] = useRestoreMenuSupplementMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMenuSupplementMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMenuSupplementMutation, RestoreMenuSupplementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMenuSupplementMutation, RestoreMenuSupplementMutationVariables>(RestoreMenuSupplementDocument, options);
      }
export type RestoreMenuSupplementMutationHookResult = ReturnType<typeof useRestoreMenuSupplementMutation>;
export type RestoreMenuSupplementMutationResult = Apollo.MutationResult<RestoreMenuSupplementMutation>;
export type RestoreMenuSupplementMutationOptions = Apollo.BaseMutationOptions<RestoreMenuSupplementMutation, RestoreMenuSupplementMutationVariables>;
export type GetDishSupplementsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  supplementId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuCategoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDishSupplementsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuSupplements?: { __typename?: 'MenuSupplementPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null, numberOfOption?: number | null, isRequireOnOrder?: boolean | null, maxCountOnOrder?: number | null, deleted: boolean, items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null }> | null, options?: Array<{ __typename?: 'MenuSupplementProxy', id: number, name?: string | null, nameOrigin?: string | null, price?: number | null, deleted: boolean }> | null }> | null } | null } | null } | null };

export type GetMenuItemsForSupplementsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuItemsForSupplementsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuItems?: { __typename?: 'MenuItemPaginated', items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null } | null }> | null }> | null } | null } | null } | null };

export type CreateMenuSupplementMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuSupplementInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateMenuSupplementMutation = { __typename?: 'Mutation', createMenuSupplement: { __typename?: 'MenuSupplementProxy', id: number } };

export type UpdateMenuSupplementMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  dishId: Types.Scalars['Int']['input'];
  input: Types.MenuSupplementInput;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateMenuSupplementMutation = { __typename?: 'Mutation', updateMenuSupplement: { __typename?: 'MenuSupplementProxy', id: number } };

export type DeleteMenuSupplementMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMenuSupplementMutation = { __typename?: 'Mutation', deleteMenuSupplement: boolean };

export type RestoreMenuSupplementMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type RestoreMenuSupplementMutation = { __typename?: 'Mutation', restoreMenuSupplement: boolean };
